import * as React from 'react';
import '../styles/DBAContentCoOp.css';

interface DBAContentsTop {
  pdfUrl: any
}

const DBAContentCoOp: React.SFC<DBAContentsTop> = props => {
  return (
    <React.Fragment>
      <iframe src={props.pdfUrl + '#zoom=120&navpanes=0&toolbar=0'} width="100%" height="430px" />
    </React.Fragment>
  );
};

export default DBAContentCoOp;


